<template>
	<layout-admin>
		<div>
			<div v-if="isLoading">
				{{ __("Loading...") }}
			</div>
			<div v-else>
				<h1>
					{{ title }}
					<a
						type="button"
						class="btn btn-primary"
						v-bind:href="sudoBecomeUrl"
						v-if="mandant != null"
					>
						{{ __("client") }} {{ mandant.company_name }}
					</a>
				</h1>
				<div id="thread-view-events" ref="threadEvents">
					<thread-show-event
						v-for="event in thread.events"
						:key="event.id"
						:thread="thread"
						:event="event"
						:disable-buttons="true"
					/>
				</div>
			</div>
		</div>
	</layout-admin>
</template>

<script>
import Vue from "vue";

export default {
	props: {
		thread: {
			type: Object,
			required: true,
		},
		mandant: {
			type: Object,
			required: false,
			default: null,
		},
	},
	data() {
		return {
			isLoading: true,
		};
	},
	async created() {
		this.thread.counterpart = this.thread.seller;
		this.thread.my_name = this.thread.buyer.company_name;
		this.isLoading = false;
		this.afterLoad();
	},
	methods: {
		afterLoad() {
			//this.scrollToBottom();

			// in admin panel, disable the action buttons - need to login as mandant
			setTimeout(function (el) {
				// $("div#thread-view-events").find("button").prop("disabled", true);
			}, 500);
		},
		scrollToBottom() {
			// scroll to most recent event
			this.$nextTick(() => {
				let container = document.getElementById("thread-view-events");
				container.scrollTop = container.scrollHeight;
			});
		},
		dismissModal() {
			this.$emit("dismiss");
		},
	},
	computed: {
		sudoBecomeUrl() {
			if (!this.mandant) {
				return null;
			}

			return (
				window.baseUrl +
				"/sudo/become/" +
				this.mandant.id +
				"/?" +
				$.param({
					to: window.baseUrl + "/thread/?active_id=" + this.thread.id,
				})
			);
		},
		title() {
			let ret = this.__("Negotiation  #") + this.thread.id;
			if (this.thread) {
				ret =
					ret +
					`: ${this.thread.buyer.company_name} (#${this.thread.buyer.id}) - ${this.thread.seller.company_name} (#${this.thread.seller.id})`;
			}
			return ret;
		},
	},
};
</script>
